import Icon from '../components/Icon.vue'

Icon.register({
  'angle-left': {
    width: 256,
    height: 512,
    paths: [
      {
        d: 'M31.7 239l136-136c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9l-96.3 96.5 96.4 96.4c9.4 9.4 9.4 24.6 0 33.9l-22.6 22.7c-9.4 9.4-24.6 9.4-33.9 0l-136-136c-9.5-9.4-9.5-24.6-0.1-34z'
      }
    ]
  }
})
